import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { SERVER_URL } from "../constant";
import PaginationBar from "../component/PaginationBar";
import { Link } from "react-router-dom";
import ButtonCompo from "../component/ButtonCompo";
import { FaCheckCircle } from "react-icons/fa";
import { IoAlertCircleSharp } from "react-icons/io5";
import InputField from "../component/InputField";
import SelectField from "../component/SelectField";
import AlertBox from "../component/AlertBox";

function Cards({ title, yearAmount, monthAmount }) {
  return (
    <section className="w-full border px-5 py-3 rounded-[10px] shadow-md cursor-pointer hover:shadow-lg">
      <p className="text-[17px] font-medium">{title}</p>
      <div className="w-full flex items-center justify-between mt-3">
        <div>
          <p className="text-slate-500 font-normal text-[15px]">Yearly</p>
          <p className="mt-1 font-medium">{yearAmount}</p>
        </div>
        <div>
          <p className="text-slate-500 font-normal text-right text-[15px]">
            Monthly
          </p>
          <p className="mt-1 font-medium text-right">{monthAmount}</p>
        </div>
      </div>
    </section>
  );
}

function EmployeeSalary() {
  const employeeData = useSelector((state) => state?.employee?.employeeData);
  const salaryStructure = employeeData?.salaryStructure || [];
  const [page, setPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [payslipData, setpayslipData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [monthsArr, setMonthsArr] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  // tricky part. Always show the data of previous month.
  const [selectedYear, setSelectedYear] = useState(() => {
    if (new Date().getMonth() === 0) {
      return new Date().getFullYear() - 1;
    } else {
      return new Date().getFullYear();
    }
  });
  const [selectedMonth, setSelectedMonth] = useState(() => {
    if (new Date().getMonth() === 0) {
      return 11;
    } else {
      return new Date().getMonth() - 1;
    }
  });

  async function getPayslipData() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/payslip/all/${page}?month=${selectedMonth}&year=${selectedYear}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data?.data);
      setpayslipData(res.data?.data?.data || []);
      setTotalPage(res.data?.data?.totalPages);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  const monthDropDownArr = [
    { title: "January", value: 0 },
    { title: "February", value: 1 },
    { title: "March", value: 2 },
    { title: "April", value: 3 },
    { title: "May", value: 4 },
    { title: "June", value: 5 },
    { title: "July", value: 6 },
    { title: "August", value: 7 },
    { title: "September", value: 8 },
    { title: "October", value: 9 },
    { title: "November", value: 10 },
    { title: "December", value: 11 },
  ];

  useEffect(() => {
    getPayslipData();
  }, [page, selectedMonth, selectedYear]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full justify-center items-center flex py-5">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw]">
          <h1 className="text-[30px] font-medium text-left w-full">
            Salary & Payslips
          </h1>
          <div className="grid grid-cols-2 gap-5 mt-5">
            <section className="w-full border px-5 py-3 rounded-[10px] shadow-md cursor-pointer hover:shadow-lg flex justify-between items-start">
              <p className="text-[17px] font-medium">CTC</p>
              <p className="font-medium text-[20px]">₹{employeeData?.ctc}</p>
            </section>
            <section className="w-full border px-5 py-3 rounded-[10px] shadow-md cursor-pointer hover:shadow-lg flex justify-between items-start">
              <p className="text-[17px] font-medium">In Hand</p>
              <p className="font-medium text-[20px]">₹{employeeData?.inHand}</p>
            </section>
          </div>
          <div className="w-full mt-5">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3">
              {salaryStructure?.map((salaryData, i) =>
                Number(salaryData?.amount) > 0 ? (
                  <Cards
                    title={salaryData?.name}
                    yearAmount={salaryData?.amount}
                    monthAmount={Math.floor(Number(salaryData?.amount) / 12)}
                  />
                ) : (
                  ""
                )
              )}
            </div>
          </div>
          <div className="w-full mt-7">
            <div className="mb-5">
              <section className="flex w-[20rem] gap-3">
                <InputField
                  label="Year"
                  value={selectedYear}
                  onChange={(eve) => setSelectedYear(eve?.target?.value)}
                  type="number"
                />
                <SelectField
                  label={"Month"}
                  value={selectedMonth}
                  setValue={(eve) => setSelectedMonth(eve?.target?.value)}
                  valueArray={monthDropDownArr}
                />
              </section>
            </div>
            <Table>
              <TableHead>
                <TableRow className="!bg-blue-500">
                  <TableCell className="!text-white">Month</TableCell>
                  <TableCell className="!text-white">Year</TableCell>
                  <TableCell className="!text-white">Salary Cr</TableCell>
                  <TableCell className="!text-white">
                    Download Payslip
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {payslipData?.map((payslip, i) => (
                  <TableRow>
                    <TableCell>{monthsArr[payslip?.month]}</TableCell>
                    <TableCell>{payslip?.year}</TableCell>
                    <TableCell>{payslip?.amount}</TableCell>
                    <TableCell>
                      {payslip?.payslipUrl !== undefined &&
                      payslip?.payslipUrl !== "" ? (
                        <Link to={payslip?.payslipUrl} target="_blank">
                          <ButtonCompo
                            color={"success"}
                            startIcon={<FaCheckCircle size={17} />}
                          >
                            payslip
                          </ButtonCompo>
                        </Link>
                      ) : (
                        <ButtonCompo
                          color={"error"}
                          startIcon={<IoAlertCircleSharp size={17} />}
                        >
                          payslip
                        </ButtonCompo>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <PaginationBar
              attendancePage={page}
              setAttendancePage={setPage}
              totalAttendancePage={totalPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeSalary;
